// extracted by mini-css-extract-plugin
export default {"wrapper":"LiqEd","figure":"tZhhX","content":"j5hrb"};